import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Card } from '@/components/Card';
import { Button } from '@/components/Button';
import { Link } from 'react-router-dom';

export const AdminDashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8 rounded-3xl border border-gray-200 bg-gradient-to-r from-slate-50 via-white to-amber-50 p-6 shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
        <p className="mt-2 text-gray-600">Welcome back, {user?.name}!</p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Card className="p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Quick Actions</h2>
          <div className="space-y-3">
            <Link to="/admin/article-statistics">
              <Button className="w-full" variant="secondary">
                Article statistics
              </Button>
            </Link>
            <Link to="/admin/users/create">
              <Button className="w-full">Create Editor Account</Button>
            </Link>
            <Link to="/admin/users">
              <Button className="w-full" variant="secondary">
                Manage Users
              </Button>
            </Link>
            <Link to="/editor/articles">
              <Button className="w-full" variant="secondary">
                Manage Articles
              </Button>
            </Link>
            <Link to="/editor/articles" state={{ activeTab: 'dictionary' }}>
              <Button className="w-full" variant="secondary">
                Open Dictionary
              </Button>
            </Link>
          </div>
        </Card>

        <Card className="p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Recent Activity</h2>
          <div className="space-y-3">
            <div className="border-l-4 border-blue-500 pl-3 py-2">
              <p className="text-sm font-medium">New editor account created</p>
              <p className="text-xs text-gray-500">2 hours ago</p>
            </div>
            <div className="border-l-4 border-green-500 pl-3 py-2">
              <p className="text-sm font-medium">Article published</p>
              <p className="text-xs text-gray-500">5 hours ago</p>
            </div>
            <div className="border-l-4 border-yellow-500 pl-3 py-2">
              <p className="text-sm font-medium">Article pending review</p>
              <p className="text-xs text-gray-500">1 day ago</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
